import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  WebSocketConnectionStatus,
  PriceUpdateMessage,
  CompetitorPriceMessage,
  PriceAlertMessage,
  MarketChangeMessage,
  AnalyticsUpdateMessage,
  SystemAlertMessage
} from '../../shared/interfaces/websocket.interfaces';
import { ProductPriceData, PriceAlert, MarketMetrics } from '../../core/services/real-time-price.service';

export const WebSocketActions = createActionGroup({
  source: 'WebSocket',
  events: {
    // Connection Management
    'Connect': props<{ token?: string }>(),
    'Connect Success': emptyProps(),
    'Connect Failure': props<{ error: any }>(),
    'Disconnect': emptyProps(),
    'Connection Status Changed': props<{ status: WebSocketConnectionStatus }>(),
    'Reconnect Attempt': props<{ attempt: number }>(),
    'Max Reconnect Attempts Reached': emptyProps(),
    
    // Subscription Management
    'Subscribe To Products': props<{ productIds: string[] }>(),
    'Unsubscribe From Products': props<{ productIds: string[] }>(),
    'Subscribe To Dashboard': emptyProps(),
    'Unsubscribe From Dashboard': emptyProps(),
    
    // Real-time Message Processing
    'Price Update Received': props<{ updates: PriceUpdateMessage[] }>(),
    'Competitor Price Received': props<{ update: CompetitorPriceMessage }>(),
    'Price Alert Received': props<{ alert: PriceAlertMessage }>(),
    'Market Change Received': props<{ change: MarketChangeMessage }>(),
    'Analytics Update Received': props<{ update: AnalyticsUpdateMessage }>(),
    'System Alert Received': props<{ alert: SystemAlertMessage }>(),
    
    // Message Queue Management
    'Queue Message': props<{ event: string; data?: any }>(),
    'Process Message Queue': emptyProps(),
    'Clear Message Queue': emptyProps(),
    
    // Error Handling
    'WebSocket Error': props<{ error: any }>(),
    'Clear WebSocket Error': emptyProps()
  }
});

export const RealTimePriceActions = createActionGroup({
  source: 'Real Time Price',
  events: {
    // Price Data Management
    'Update Product Prices': props<{ prices: ProductPriceData[] }>(),
    'Update Single Product Price': props<{ productId: string; priceData: ProductPriceData }>(),
    'Clear Product Prices': emptyProps(),
    
    // Competitor Data
    'Update Competitor Prices': props<{ productId: string; competitors: any[] }>(),
    
    // Alert Management
    'Add Price Alert': props<{ alert: PriceAlert }>(),
    'Update Price Alerts': props<{ alerts: PriceAlert[] }>(),
    'Acknowledge Alert': props<{ alertId: string }>(),
    'Clear Acknowledged Alerts': emptyProps(),
    'Clear All Alerts': emptyProps(),
    
    // Market Metrics
    'Update Market Metrics': props<{ metrics: MarketMetrics }>(),
    
    // Configuration
    'Update Monitoring Config': props<{ config: any }>(),
    
    // Subscription Management
    'Subscribe To Product Monitoring': props<{ productId: string }>(),
    'Unsubscribe From Product Monitoring': props<{ productId: string }>(),
    'Subscribe To Multiple Products': props<{ productIds: string[] }>(),
    
    // Error Handling
    'Real Time Price Error': props<{ error: any }>(),
    'Clear Real Time Price Error': emptyProps()
  }
});

// Combined actions for easier imports
export const RealtimeActions = {
  WebSocket: WebSocketActions,
  RealTimePrice: RealTimePriceActions
};